// extracted by mini-css-extract-plugin
export default {"separator":"StatementSeparator_separator__72qeh"};